import React from 'react';
import './VersionMismatchOverlay.css';
import {APP_VERSION} from '../../constants/version';

/**
 * Оверлей «обновиться не удалось»: показывается, только если автоперезагрузка
 * в этой вкладке уже была, а версия все равно разошлась с серверной
 * (см. checkAppVersion). Версии выведены на экран специально — по скриншоту
 * игрока сразу видно, кто из двоих отстал
 */
function VersionMismatchOverlay({serverVersion}) {
  const handleReload = () => {
    window.__skipBeforeUnload = true;
    window.location.reload();
  };

  return (
    <div className="version-mismatch-overlay">
      <h2 className="version-mismatch-title">Приложение устарело</h2>
      <p className="version-mismatch-text">
        Обнаружена новая версия игры, но автоматическое обновление не удалось.
      </p>
      <p className="version-mismatch-text">
        Нажмите кнопку ниже, чтобы перезагрузить страницу.
      </p>
      <p className="version-mismatch-versions">
        Версия приложения: {APP_VERSION}
        {serverVersion ? `, версия сервера: ${serverVersion}` : ''}
      </p>
      <p className="version-mismatch-hint">
        Если после перезагрузки вы снова видите это окно — очистите кеш и историю браузера,
        либо откройте игру в режиме "Инкогнито".
      </p>
      <button className="version-mismatch-button" onClick={handleReload}>
        Перезагрузить страницу
      </button>
    </div>
  );
}

export default VersionMismatchOverlay;
